import React from 'react';
import { useAppSelector } from '../store/hooks';
import { useSwipe } from '../store/useSwipe';
const Aqipage: React.FC = () => {
  const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();
    const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
    const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
    const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
    const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);
     
  const aqiSrc = 'https://www.aqi.in/widget?p=eyJvX3ciOjEsIm9fd190X3UiOiJjIiwib190IjoibCIsIndfdF9pIjozLCJscyI6W3sicyI6ImluZGlhL2RlbGhpL25ldy1kZWxoaSJ9LHsicyI6ImluZGlhL3JhamFzdGhhbi9qYWlwdXIifSx7InMiOiJpbmRpYS9tYWhhcmFzaHRyYS9wdW5lIn0seyJzIjoiaW5kaWEvY2hhbmRpZ2FyaCJ9LHsicyI6ImluZGlhL21haGFyYXNodHJhL211bWJhaSJ9LHsicyI6ImluZGlhL3V0dGFyLXByYWRlc2gvbHVja25vdyJ9XX0=';

  return (
     <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
        <main
        className="home-container"       
       style={{ height: `calc(100vh - ${fooNavHeight+10}px)`, overflowY: 'auto', paddingTop:headerHeight+10}}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}>
    
      <div className="max-w-4xl mx-auto space-y-4 px-3">
        {/* Page Header */}
        <h1 className={`font-bold mb-0 ${fontSize === 'small' ? 'text-lg' : fontSize === 'large' ? 'text-2xl' : 'text-xl'}`}>
                      {"AQI-Index"}
        </h1>

        {/* Directors Block */}
        <div className={`rounded-2xl shadow-md p-6 md:p-10 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
          <iframe
            src={aqiSrc}
            title="AQI Widget"
            loading="lazy"
            style={{ width: '100%', height: '70vh', border: '0', overflow: 'hidden' }}
          />
        </div>
      </div>
      </main>
    </div>
  );
};

export default Aqipage;
